import { FormConstants } from '../../../constants/form.constants';
import { EnrollmentContextService } from '../enrollment-context';
import { ContactPoint } from '../types';

export const telecomMapper = (enrollmentContext: EnrollmentContextService) => {
	const telecom: ContactPoint[] = [];
	fillTelecomEmail(enrollmentContext, telecom);
	fillTelecomPhoneUsage(enrollmentContext, telecom);
	fillTelecomBestCommunication(enrollmentContext, telecom);
	return telecom;
};

function fillTelecomBestCommunication(
	enrollmentContext: EnrollmentContextService,
	telecom: ContactPoint[]
) {
	const bestCommunication =
		enrollmentContext.getFormField('bestCommunication')?.value;
	if (bestCommunication) {
		if (bestCommunication === 'text') {
			telecom.push({
				...telecom.find((tel) => tel.use === 'mobile')!,
				system: 'sms',
			});
		}
		telecom.forEach((tel) => {
			tel.rank = 2;
			if (bestCommunication === 'email' && tel.system === 'email') {
				tel.rank = 1;
			}
			if (bestCommunication === 'call' && tel.use === 'mobile') {
				tel.rank = 1;
			}
			if (bestCommunication === 'text' && tel.system === 'sms') {
				tel.rank = 1;
			}
		});
	}
}

function fillTelecomPhoneUsage(
	enrollmentContext: EnrollmentContextService,
	telecom: ContactPoint[]
) {
	telecom.push({
		system: FormConstants.phone,
		value: enrollmentContext
			.getFormField(FormConstants.phone)
			?.value?.toString(),
		use:
			enrollmentContext.getFormField(FormConstants.phoneUsage)?.value ===
			FormConstants.phoneUsageHome
				? FormConstants.phoneUsageHome
				: FormConstants.phoneUsageMobile,
	});
	if (enrollmentContext.getFormField(FormConstants.phoneUsageMobile)?.value) {
		telecom.push({
			system: FormConstants.phone,
			value: enrollmentContext
				.getFormField(FormConstants.phoneUsageMobile)
				?.value?.toString(),
			use: FormConstants.phoneUsageMobile,
		});
	}
}

function fillTelecomEmail(
	enrollmentContext: EnrollmentContextService,
	telecom: ContactPoint[]
) {
	if (enrollmentContext.getFormField('email')?.value) {
		telecom.push({
			system: 'email',
			value: enrollmentContext.getFormField('email')?.value?.toString(),
			use: 'home',
		});
	}
}
